import { z } from "zod";
import { oc } from "@orpc/contract";
//#region src/api/orpc/contentSafetyPreference.ts
const modifiedAtSchema = z.iso.datetime().nullable().meta({ description: "Last modified timestamp, null if never set" });
const nullDescription = "null means the preference is not set.";
const contentSafetyPreferencesSchema = z.object({
	ageVerified: z.object({
		value: z.enum(["adult", "minor"]).nullable().meta({ description: `'adult' | 'minor' | null. ${nullDescription}` }),
		modifiedAt: modifiedAtSchema
	}).meta({ description: "Age verification status" }),
	blurNsfw: z.object({
		value: z.enum(["blur", "show"]).nullable().meta({ description: `'blur' | 'show' | null. ${nullDescription}` }),
		modifiedAt: modifiedAtSchema
	}).meta({ description: "NSFW content blur preference" }),
	showNsfw: z.object({
		value: z.enum(["show", "hide"]).nullable().meta({ description: `'show' | 'hide' | null. ${nullDescription}` }),
		modifiedAt: modifiedAtSchema
	}).meta({ description: "NSFW content visibility preference" })
});
const updateContentSafetyPreferenceInputSchema = z.discriminatedUnion("key", [
	z.object({
		key: z.literal("age-verified"),
		value: z.enum(["adult", "minor"])
	}),
	z.object({
		key: z.literal("blur-nsfw"),
		value: z.enum(["blur", "show"])
	}),
	z.object({
		key: z.literal("show-nsfw"),
		value: z.enum(["show", "hide"])
	})
]);
const updateContentSafetyPreferenceOutputSchema = contentSafetyPreferencesSchema.partial();
const contentSafetyPreferenceContract = oc.prefix("/me/content-safety/preferences").tag("Content Safety Preference").router({
	getContentSafetyPreferences: oc.route({
		summary: "Get content safety preferences for current user",
		method: "GET",
		path: "/"
	}).output(contentSafetyPreferencesSchema).errors({ UNAUTHORIZED: {
		status: 401,
		message: "User not authenticated"
	} }),
	updateContentSafetyPreference: oc.route({
		summary: "Update a content safety preference",
		method: "PUT",
		path: "/{key}"
	}).input(updateContentSafetyPreferenceInputSchema).output(updateContentSafetyPreferenceOutputSchema).errors({ UNAUTHORIZED: {
		status: 401,
		message: "User not authenticated"
	} })
});
//#endregion
export { contentSafetyPreferenceContract };
